import store from '@advisor/store';
import {pageView} from '@advisor/util/common/analytics';

const disableLoading = () => {
  store.dispatch('setLoading', false);
};

// eslint-disable-next-line require-await
const trackPageView = async (to, from) => {
  pageView(to, from);
};

// eslint-disable-next-line import/prefer-default-export
export const afterEach = [disableLoading, trackPageView];
